import { ChevronRightIcon } from '@fronton/icons-react';
import { useMediaQuery } from 'common/hooks';
import { RegularButton, Typography } from 'fronton-react';
import { MobileWrapper, Wrapper } from './styled';
import React from 'react';

export const GoToAllServicesCard = () => {
	const isMobile = useMediaQuery('(max-width: 767px)');

	const handleRedirect = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	if (isMobile) {
		return (
			<MobileWrapper
				to={`/uslugi`}
				onClick={handleRedirect}
				data-qa="go-to-all-services-card"
			>
				<Typography variant="m" size="body_short">
					Смотреть всё
				</Typography>

				<ChevronRightIcon
					type="outline"
					size="l"
					color="text-primary"
					data-qa="chevron-right-icon"
				/>
			</MobileWrapper>
		);
	}

	return (
		<Wrapper to={`/uslugi`} onClick={handleRedirect} data-qa="go-to-all-services-card">
			<RegularButton iconOnly label="chevron" rounded size="l" variant="secondary">
				<ChevronRightIcon data-qa="chevron-right-icon" />
			</RegularButton>

			<Typography variant="m" size="body_short">
				Смотреть все услуги
			</Typography>
		</Wrapper>
	);
};
